import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { ClientStoreService } from '../../../../services/client-store.service';
import { ViewRecord } from '../view.component';
import { get } from 'lodash-es';
import { SubscriptionRestrictionService } from '../../../../services/subscription-restriction/subscription-restriction.service';
import { SubscriptionId } from '../../../../objects/subscription-plans';
import { LooseObject } from '../../../../objects/loose-object';
import { ApiService } from '../../../../services/api.service';
import { data_get, filled } from '../../../utils/common';
import { filter } from 'rxjs/operators';
import { NotificationService } from '../../../../services/notification.service';
import { RecordService } from '../../../../services/record.service';

@Component({
  selector: 'app-view-actions-button',
  templateUrl: './actions-button.component.html',
  styleUrls: [
    './actions-button.component.scss'
  ],
})
export class ViewActionsButtonComponent implements OnInit {
  /**
   * @type {string}
   *
   * @readonly
   */
  @Input('module') readonly module: string;

  /**
   * @type {Action[]}
   */
  @Input('actions') actions: Action[] = [];

  /**
   * @type {ViewRecord}
   *
   * @readonly
   */
  @Input('record') readonly record: ViewRecord;

  /**
   * flag that open's the create form
   *
   */
  @Output() bOpenDuplicate = new EventEmitter<boolean>();

  @Output() webhookOutput = new EventEmitter<any>();

  customButtons: LooseObject = {};

  /**
   * Create instance of the component
   *
   * @param {ClientStoreService} clients
   * @param {Injector} ctx
   */
  constructor(
    protected readonly clients: ClientStoreService,
    protected readonly ctx: Injector,
    protected readonly subscription: SubscriptionRestrictionService,
    private readonly _api: ApiService,
    private _notifications: NotificationService,
    private recordService: RecordService
  ) {}

  /**
   * @inheritdoc
   */
  ngOnInit(): void {
    const client = this.clients.getActiveClient();

    this.recordService.getCustomButtonConfig(this.module).subscribe((response) => {
      this.customButtons = response;
    })

    // filters all the actions if current active user has allowed a specific permission
    this.actions = this.actions.filter(
      (action) => {
        let viewable = true;

        if (action.allows !== undefined) {
          viewable =  get(client, 'enable_' + action.allows, false);
        }

        if (action.min_subscription_required !== undefined) {
          viewable = this.subscription.subscriptionPlanIsGreaterThanOrEqualTo(client, action.min_subscription_required);
        }

        return viewable
      }
    );
  }

  /**
   * Handles action click
   *
   * @param {Action} action
   * @param {Event}  ev
   *
   * @returns {void}
   */
  onClick(action: Action, ev: Event): void {
    const strId = get(action, 'id');
    if (strId == 'duplicate_record') {
      this.bOpenDuplicate.next(true);
    } else {
      return action.handle(this.record, this.ctx, ev);
    }
  }

  onCustomBtnClick(button) {
    this._api.callPrivate$({
        action: 'post',
        path: '/workflow/test-webhook-endpoint',
        expectsNewFormat: true,
        body: {
          data: button,
          module_name: this.module,
          record_id: data_get(this.record, 'id'),
          is_custom_btn: true
        },
        onSuccessResponse: (response) => ({
          status_code: response.get('status'),
          http_body: response.get('body'),
        }),
    }).pipe(
      filter(filled),
    ).subscribe((result) => {
      if (result.status_code >= 200 && result.status_code <= 299) {
          let httpBody = JSON.parse(result.http_body);
          this.webhookOutput.next(httpBody);
          if (filled(httpBody.message)) {
            return this._notifications.notifySuccess(httpBody.message);
        } else {
          return this._notifications.notifySuccess('Endpoint responded successfully.');
        }
      } else {
        this._notifications.notifyError('webhook_error');
      }
    });
  }
}

export interface Action {
  id: string;
  label: string;
  handle: (record: ViewRecord, ctx: Injector, ev: Event) => void;
  allows?: string;
  min_subscription_required?: SubscriptionId;
}